import InputSingleline from 'app/shared-components/InputSingleline'

import {
    DefaultAttachment,
} from '../../utils/OrderNotifications.types'

import useStyles from './DefaultAttachments.style'

type Props = {
    value?: DefaultAttachment[],
}

const defaultProps = {
    value: [],
}

const DefaultAttachments = ({
    value,
}: Props) => {
    const {
        classes,
    } = useStyles()

    return (
        <>
            {!value.length && (
                <div className={classes.emptyMsg}>
                    This notification does not have any documents attached.
                </div>
            )}
            {Boolean(value.length) && (
                value.map(({
                    id,
                    fileName,
                }) => {
                    return (
                        <InputSingleline
                            key={`def-attachment-${id}`}
                            value={fileName}
                            disabled
                        />
                    )
                })
            )}
        </>
    )
}

DefaultAttachments.defaultProps = defaultProps

export default DefaultAttachments
